<nav class="navbar navbar-expand-md" *ngIf="!!selectedCustomer">
  <button class="navbar-toggler btn" type="button" (click)="toggleMobileMenu()">
    <i class="fas fa-bars"></i>
  </button>
  <div class="collapse navbar-collapse justify-content-end" [ngClass]="baseCollapseClasses">
    <ul class="navbar-nav" *ngIf="authenticated">
      <li class="nav-item">
        <div ngbDropdown display="dynamic" placement="bottom-left auto">
          <button class="btn" ngbDropdownToggle>
            <span translate>PRODUCTS</span>
            <i class="fas fa-arrow-down ml-1"></i>
          </button>
          <div ngbDropdownMenu class="documents-dropdown-menu">
            <a *ngFor="let link of subassortments" class="dropdown-item" routerLinkActive="active"
              [routerLink]="link.route" translate>{{ link.heading }}</a>
          </div>
        </div>
      </li>
      <li class="nav-item" *ngIf="!onlyUserPermission">
        <button class="btn" routerLink="/customers/{{ selectedCustomer.id }}">
          <span>{{ selectedCustomer.name }}({{ selectedCustomer.id }})</span>
        </button>
      </li>
      <li class="nav-item">
        <button class="btn" [routerLink]="'digital-assets'">
          <span translate>DIGITAL_ASSETS</span>
        </button>
      </li>
      <!--
      <li class="nav-item">
        <div ngbDropdown display="dynamic" placement="bottom-left auto"
          *ngIf="documentsList && documentsList.length > 0">
          <button class="btn" ngbDropdownToggle>
            <span translate>DOCUMENTS</span>
            <i class="fas fa-arrow-down ml-1"></i>
          </button>
          <div ngbDropdownMenu class="documents-dropdown-menu">
            <a *ngFor="let documentItem of documentsList" ngbDropdownItem [href]="documentItem.url" target="_blank">
              <button class="btn">
                <span translate>{{documentItem.document.metaData.description || documentItem.document.filename}}</span>
              </button>
            </a>
          </div>
        </div>
      </li>
      -->
      <li class="nav-item" ngbDropdown>
        <button class="btn" ngbDropdownToggle>
          <span translate>MY_ACCOUNT</span>
          <i class="fas fa-arrow-down ml-1"></i>
        </button>
        <div ngbDropdownMenu aria-labelledby="myPagesDropdown" class="dropdown-menu">
          <a *ngFor="let link of extraLinks" class="dropdown-item" routerLinkActive="active" [routerLink]="link.route"
            [queryParams]="link.queryParams ? link.queryParams : undefined"
            [queryParamsHandling]="(link.queryParams && link.queryParamsHandling) || ''" translate>{{ link.heading
            }}</a>
          <a class="dropdown-item" routerLink="/customers/{{ selectedCustomer.id }}">
            <span translate>CUSTOMER_DETAILS</span>
          </a>
          <a class="dropdown-item" *ngIf="isSales" routerLink="/customers">
            <span translate>MY_CUSTOMERS</span>
          </a>
          <div class="dropdown-item" *ngIf="!isNoPrice">
            <label class="switch">
              <input id="hidePrice" name="hidePrice" type="checkbox" #hidePriceInput
                (change)="hidePrice(hidePriceInput)" />
              <span class="slider round bg-primary"></span>
            </label>
            <label for="hidePrice" class="ml-1" translate>HIDE_PRICE</label>
          </div>
          <a class="dropdown-item bg-primary text-white" routerLink="/" (click)="logout()" translate>SIGN_OUT</a>
        </div>
      </li>
    </ul>
    <ul class="navbar-nav" *ngIf="!authenticated">
      <li class="nav-item">
        <a class="nav-link" routerLink="/" translate>SIGN_IN</a>
      </li>
    </ul>
  </div>
  <a class="navbar-brand" routerLink="/home">
    <img src="./assets/logov2.png" width="auto" height="36px" alt="Logotype" class="d-none d-md-block" />
    <img src="./assets/logo.png" width="auto" height="36px" alt="Logotype" class="d-block d-md-none" />
  </a>
  <div *ngIf="!authenticated" class="">
    <lib-lang-select></lib-lang-select>
  </div>
  <div *ngIf="authenticated" class="mr-3">
    <colmec-navbar-cart></colmec-navbar-cart>
  </div>
</nav>
